<template>
    
    <div>
        <nav class="p-2 border-bottom border-primary">
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
             @click="mostraListaImpianti"
            >Lista Impianti</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraPaginaUtentiPendenti"
            >Lista Utenti in attesa validazione</b-button>
            <b-button
            :pressed="true"
            class="typo-label"
            variant="link"
            >Lista Utenti</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraPaginaCodiciPro"
            >Gestione Codici Pro</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'"
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraRiepilogo"
            >Riepilogo</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'" 
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraMappa"
            >Mappa</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'"
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraAldi"
            >Report Aldi</b-button>
        </nav>
        <Loader />
        <div v-if="!authorized && !pageloading" class="mt-4 center">
            <h3>Non sei autorizzato ad accedere a questa risorsa</h3>
        </div>
        <div v-if="!pageloading && authorized" class="animated fadeIn container-fluid">
            <b-row>
                <b-col md="10" offset-md="1" lg="6" offset-lg="3" class="py-4 text-center">
                    <b-form-group>
                        <b-input-group>
                        <!-- Attach Left button -->
                        <b-input-group-prepend>
                            <b-input-group-text>Cerca:</b-input-group-text>
                            
                        </b-input-group-prepend>
                        <b-form-input type="text" placeholder="" v-model="searchFilter"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="primary">
                                <i class="fa fa-search"></i>
                            </b-button>
                        </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col class="center">
                    <b-table id="ntoTable" :per-page="rpp" :current-page="tabPage" sticky-header="500px" 
                        :striped="true" :hover="true" :items="filteredList" :fields="tableFields" 
                        :outlined="true" >

                        <template v-slot:cell(address)="data">
                            <strong>{{data.value.city}} ({{data.value.prov}}) {{data.value.country}}</strong><br/>
                            {{data.value.cap}} -  {{data.value.street}} {{data.value.housenumber}}
                        </template>

                        <template v-slot:cell(phone)="{ item: item }">
                            tel: <strong>{{item.phone}} </strong><br/>
                            email: <strong>{{item.username}} </strong>
                        </template>
                                                
                    </b-table>
                </b-col>
            </b-row>
            <b-navbar v-if="allUsers != null && allUsers.length > 0" type="light" fixed="bottom" class="bottomNav"> 
                <b-nav-text class="mx-auto">
                    <span class="totLabel">Totale records filtrati: {{filteredList.length}}</span>
                    <b-pagination
                        v-model="tabPage"
                        :total-rows="filteredList.length"
                        :per-page="rpp"
                        aria-controls="ntoTable"
                        ></b-pagination>
                </b-nav-text>
            </b-navbar>
        </div>
    </div>


</template>

<script>

import { Auth } from 'aws-amplify'
import { API } from 'aws-amplify'
//import * as Axios from 'axios'

import { mapState, install } from 'vuex';


import router from '../router/approuter'
import {showAt, hideAt} from 'vue-breakpoints'


export default {
    name: 'NTOUsers',
    components: {
        hideAt, showAt

    },    
    props: [],
    data() {
        return {
            userId: null,
            pageloading: true,
            searchFilter: "",
            authorized: false,
            dataLoaded: false,
            allUsers: [],
            tabPage: 1,
            rpp: 50,
            tableFields: [
                {
                    key: 'businessname',
                    label: 'Rag Soc',
                    sortable: true
                },
                {
                    key: 'name',
                    label: 'Nome',
                    sortable: true
                },
                {
                    key: 'surname',
                    label: 'Cognome',
                    sortable: true
                },
                {
                    key: 'address',
                    label: 'Indirizzo',
                    sortable: true
                },
                {
                    key: 'piva',
                    label: 'P.IVA',
                    sortable: true
                },
                {
                    key: 'phone',
                    label: 'Contatti',
                    sortable: false
                }
            ]
        }
    },
    created() {
        
    },
    mounted() {
        
            
            console.log("MOUNTED NTOUsers " + this.pageloading + ", user:" + this.$store.state.user);
        
            if (!this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
                //this.$store.dispatch('loadAllPlants',  this.$route.params.userId);
                const usertype = this.$store.getters.userType;
                console.log("ntousers launch loadAllUsers, " + usertype);
                if (usertype != 'admin') {
                    this.authorized = false;
                    this.pageloading = false;
                } else {
                    this.authorized = true;
                    this.pageloading = true; 
                    this.dataLoaded = true;
                    this.$store.dispatch('loadAllUsers', {userId: this.$store.state.user.username});
                }
            } 

        
    },
    updated() {
        
        console.log("updated ntousers");
        
    },
    computed: {
         ...mapState(['loading']),
         filteredList() {

             var records = this.allUsers;

            if (this.searchFilter != '') records = this.allUsers.filter(user => {
            return ((user.businessname ||'').toLowerCase().includes(this.searchFilter.toLowerCase()) 
                    || ((user.address && user.address.street) || '').toLowerCase().includes(this.searchFilter.toLowerCase())
                    || ((user.address && user.address.city) || '').toLowerCase().includes(this.searchFilter.toLowerCase())
                    || ((user.address && user.address.prov) || '').toLowerCase().includes(this.searchFilter.toLowerCase())
                    || ((user.address && user.address.country) || '').toLowerCase().includes(this.searchFilter.toLowerCase())
                    || (user.name ||'').toLowerCase().includes(this.searchFilter.toLowerCase())
                    || (user.surname || '').toLowerCase().includes(this.searchFilter.toLowerCase())
                    || (user.phone || '').toLowerCase().includes(this.searchFilter.toLowerCase())
                    || (user.piva || '').toLowerCase().includes(this.searchFilter.toLowerCase())
                    || (user.username || '').toLowerCase().includes(this.searchFilter.toLowerCase())
                    )
            })
            
            return records.map(user => {
                if (user.validation == 'pending')  {
                    user["_rowVariant"] = 'warning';
                } else if (user.validation == 'suspended') {
                    user["_rowVariant"] = 'danger';
                }
                return user;
            })
         }
    },  
     watch: {
        loading(val,oldval) {
            console.log("ntousers loading changed:" + val+ ", authorized=" + this.authorized+", pageLoading:" + this.pageloading);
            
            if (val == false && this.pageloading == true) {
                let self = this;
                if (! this.dataLoaded) {
                    const usertype = this.$store.getters.userType;
                    if (usertype == 'admin') {
                        this.authorized = true;
                        this.pageloading = true;
                        this.dataLoaded = true;
                        this.$store.dispatch('loadAllUsers', {userId: this.$store.state.user.username});
                    }
                    return;
                }
                this.allUsers = this.$store.state.allUsers.filter(user => {
                        return user.id != self.$store.state.user.username;
                } 
                );
                this.pageloading = false;
            }
        }
     },        
    methods: {
        mostraListaImpianti() {
            router.push({ name: 'NTOHome'})
        },
        mostraPaginaUtentiPendenti() {
            router.push({ name: 'NTOPendingUsers'})
        },
        mostraPaginaCodiciPro() {
            router.push({ name: 'NTOProCodes'})
        },
        
        mostraRiepilogo() {
            router.push({ name: 'NTOSummary'})
        },
        mostraMappa() {
            router.push({ name: 'NTOPlantsMap'})
        },
        mostraAldi() {
            router.push({ name: 'NTOAldi'})
        },

        loadAllUsers() {
            this.$store.dispatch('loadAllUsers',{userId: this.$store.state.user.username});
        },
    }

}
</script>

<style lang="scss" scoped>
    .bottomNav {
        bottom:60px;
        //background-color: #fff;
    }
    .totLabel {
        font-family: 'Roboto',sans-serif;
        font-size: 14px;
        font-weight: bold;
        color: #333;
    }
    

</style>